import { AdminLayout } from '../components/AdminLayout';
import { CinemaSection } from '../components/cinema/CinemaSection';
import { LABELS } from '../../data/labels';

export function AdminCinema() {
  return (
    <AdminLayout title="Popcorn">
      <CinemaSection labels={LABELS.fr} />
    </AdminLayout>
  );
}
